// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".max-w-1068[data-v-35da51cc]{margin-left:auto;margin-right:auto;max-width:106.8rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
